import { useWindowEvent } from '@/lib/hooks/window'
import { heroStateFrame } from '@/lib/store/hero'
import { Link } from 'gatsby'
import * as React from 'react'
import { useRecoilState } from 'recoil'

declare module 'react' {
  interface CSSProperties {
    '--tw-scale-x'?: number
    '--tw-scale-y'?: number
  }
}

const MAX_FRAME = 100

export const Hero = (): JSX.Element => {
  const preRef = React.useRef<HTMLPreElement>(null)
  const [scale, setScale] = React.useState(1)
  const [frame, setFrame] = useRecoilState(heroStateFrame)

  const Text = React.useMemo(() => {
    if (frame < 15) {
      return <>{`ycu-engine.github.io:~ $`}</>
    }

    if (frame < 39) {
      const launch =
        frame < 25
          ? 'l'
          : frame < 27
          ? 'la'
          : frame < 29
          ? 'lau'
          : frame < 31
          ? 'laun'
          : frame < 33
          ? 'launt'
          : frame < 35
          ? 'laun'
          : frame < 37
          ? 'launc'
          : 'launch'
      return <>{`ycu-engine.github.io:~ $ ${launch}`}</>
    }
    if (frame < 80) {
      const delay = [0.0, 0.3, 0.2, 0.7, 0.5]
      let rate = 0
      let time = 0
      while (frame - 44 > time) {
        time += delay[rate % 5] || 0
        if (rate < 100) {
          rate++
        } else {
          break
        }
      }
      return (
        <>{`ycu-engine.github.io:~ $ launch
|${'#'.repeat(rate)}${rate < 100 ? ' '.repeat(100 - rate) : ''}| ${rate}%`}</>
      )
    }
    let text = `ycu-engine.github.io:~ $ launch
|${'#'.repeat(100)}| 100%
`
    if (frame < 81) {
      text += `██╗    ██╗
██║    ██║
██║ █╗ ██║
██║███╗██║
╚███╔███╔╝
 ╚══╝╚══╝ `
    } else if (frame < 82) {
      text += `██╗    ██╗███████╗
██║    ██║██╔════╝
██║ █╗ ██║█████╗  
██║███╗██║██╔══╝  
╚███╔███╔╝███████╗
 ╚══╝╚══╝ ╚══════╝`
    } else if (frame < 83) {
      text += `██╗    ██╗███████╗██╗      
██║    ██║██╔════╝██║     
██║ █╗ ██║█████╗  ██║     
██║███╗██║██╔══╝  ██║     
╚███╔███╔╝███████╗███████╗
 ╚══╝╚══╝ ╚══════╝╚══════╝`
    } else if (frame < 84) {
      text += `██╗    ██╗███████╗██╗      ██████╗
██║    ██║██╔════╝██║     ██╔════╝
██║ █╗ ██║█████╗  ██║     ██║     
██║███╗██║██╔══╝  ██║     ██║     
╚███╔███╔╝███████╗███████╗╚██████╗
 ╚══╝╚══╝ ╚══════╝╚══════╝ ╚═════╝`
    } else if (frame < 85) {
      text += `██╗    ██╗███████╗██╗      ██████╗ ██████╗
██║    ██║██╔════╝██║     ██╔════╝██╔═══██╗
██║ █╗ ██║█████╗  ██║     ██║     ██║   ██║
██║███╗██║██╔══╝  ██║     ██║     ██║   ██║
╚███╔███╔╝███████╗███████╗╚██████╗╚██████╔╝
 ╚══╝╚══╝ ╚══════╝╚══════╝ ╚═════╝ ╚═════╝ `
    } else if (frame < 86) {
      text += `██╗    ██╗███████╗██╗      ██████╗ ██████╗ ███╗   ███╗
██║    ██║██╔════╝██║     ██╔════╝██╔═══██╗████╗ ████║
██║ █╗ ██║█████╗  ██║     ██║     ██║   ██║██╔████╔██║
██║███╗██║██╔══╝  ██║     ██║     ██║   ██║██║╚██╔╝██║
╚███╔███╔╝███████╗███████╗╚██████╗╚██████╔╝██║ ╚═╝ ██║
 ╚══╝╚══╝ ╚══════╝╚══════╝ ╚═════╝ ╚═════╝ ╚═╝     ╚═╝`
    } else if (frame < 88) {
      text += `██╗    ██╗███████╗██╗      ██████╗ ██████╗ ███╗   ███╗███████╗
██║    ██║██╔════╝██║     ██╔════╝██╔═══██╗████╗ ████║██╔════╝
██║ █╗ ██║█████╗  ██║     ██║     ██║   ██║██╔████╔██║█████╗  
██║███╗██║██╔══╝  ██║     ██║     ██║   ██║██║╚██╔╝██║██╔══╝  
╚███╔███╔╝███████╗███████╗╚██████╗╚██████╔╝██║ ╚═╝ ██║███████╗
 ╚══╝╚══╝ ╚══════╝╚══════╝ ╚═════╝ ╚═════╝ ╚═╝     ╚═╝╚══════╝`
    } else if (frame < 89) {
      text += `██╗    ██╗███████╗██╗      ██████╗ ██████╗ ███╗   ███╗███████╗    ████████╗
██║    ██║██╔════╝██║     ██╔════╝██╔═══██╗████╗ ████║██╔════╝    ╚══██╔══╝
██║ █╗ ██║█████╗  ██║     ██║     ██║   ██║██╔████╔██║█████╗         ██║   
██║███╗██║██╔══╝  ██║     ██║     ██║   ██║██║╚██╔╝██║██╔══╝         ██║   
╚███╔███╔╝███████╗███████╗╚██████╗╚██████╔╝██║ ╚═╝ ██║███████╗       ██║   
 ╚══╝╚══╝ ╚══════╝╚══════╝ ╚═════╝ ╚═════╝ ╚═╝     ╚═╝╚══════╝       ╚═╝   `
    } else {
      text += `██╗    ██╗███████╗██╗      ██████╗ ██████╗ ███╗   ███╗███████╗    ████████╗ ██████╗                  
██║    ██║██╔════╝██║     ██╔════╝██╔═══██╗████╗ ████║██╔════╝    ╚══██╔══╝██╔═══██╗
██║ █╗ ██║█████╗  ██║     ██║     ██║   ██║██╔████╔██║█████╗         ██║   ██║   ██║
██║███╗██║██╔══╝  ██║     ██║     ██║   ██║██║╚██╔╝██║██╔══╝         ██║   ██║   ██║
╚███╔███╔╝███████╗███████╗╚██████╗╚██████╔╝██║ ╚═╝ ██║███████╗       ██║   ╚██████╔╝
 ╚══╝╚══╝ ╚══════╝╚══════╝ ╚═════╝ ╚═════╝ ╚═╝     ╚═╝╚══════╝       ╚═╝    ╚═════╝ `

      if (frame < 91) {
        text += `\n██████████████▄▖
██████████████▜▌
████▗▄▄▄▄▄▄▄▄▄▟▌
████▐▛▀▀▀▀▀▀▀▀▀▘
██████████▄▖    
██████████▜▌    
████▗▄▄▄▄▄▟▌    
████▐▛▀▀▀▀▀▘    
██████████████▄▖
██████████████▜▌
▐▙▄▄▄▄▄▄▄▄▄▄▄▄▟▌
▝▀▀▀▀▀▀▀▀▀▀▀▀▀▀▘
`
      } else if (frame < 92) {
        text += `\n██████████████▄▖ ██████▄▖      ████▄▖
██████████████▜▌ ██████▜▌      ████▜▌
████▗▄▄▄▄▄▄▄▄▄▟▌ ████████▄▖    ████▐▌
████▐▛▀▀▀▀▀▀▀▀▀▘ ████████▜▌    ████▐▌
██████████▄▖     ████▗▄████▄▖  ████▐▌
██████████▜▌     ████▐▛████▜▌  ████▐▌
████▗▄▄▄▄▄▟▌     ████▐▌▐▙████▄▖████▐▌
████▐▛▀▀▀▀▀▘     ████▐▌▝▀████▜▌████▐▌
██████████████▄▖ ████▐▌  ▐▙████████▐▌
██████████████▜▌ ████▐▌  ▝▀████████▐▌
▐▙▄▄▄▄▄▄▄▄▄▄▄▄▟▌ ▐▙▄▄▟▌    ▐▙▄▄▄▄▄▄▟▌
▝▀▀▀▀▀▀▀▀▀▀▀▀▀▀▘ ▝▀▀▀▀▘    ▝▀▀▀▀▀▀▀▀▘
`
      } else if (frame < 93) {
        text += `\n██████████████▄▖ ██████▄▖      ████▄▖   ████████████▄▖  
██████████████▜▌ ██████▜▌      ████▜▌   ████████████▜▌  
████▗▄▄▄▄▄▄▄▄▄▟▌ ████████▄▖    ████▐▌ ████▗▄▄▄▄▄▄▄▄▄▟▌  
████▐▛▀▀▀▀▀▀▀▀▀▘ ████████▜▌    ████▐▌ ████▐▛▀▀▀▀▀▀▀▀▀▘  
██████████▄▖     ████▗▄████▄▖  ████▐▌ ████▐▌    ██████▄▖
██████████▜▌     ████▐▛████▜▌  ████▐▌ ████▐▌    ██████▜▌
████▗▄▄▄▄▄▟▌     ████▐▌▐▙████▄▖████▐▌ ████▐▌      ████▐▌
████▐▛▀▀▀▀▀▘     ████▐▌▝▀████▜▌████▐▌ ████▐▌      ████▐▌
██████████████▄▖ ████▐▌  ▐▙████████▐▌ ▐▙████████████▗▄▟▌
██████████████▜▌ ████▐▌  ▝▀████████▐▌ ▝▀████████████▐▛▀▘
▐▙▄▄▄▄▄▄▄▄▄▄▄▄▟▌ ▐▙▄▄▟▌    ▐▙▄▄▄▄▄▄▟▌   ▐▙▄▄▄▄▄▄▄▄▄▄▟▌  
▝▀▀▀▀▀▀▀▀▀▀▀▀▀▀▘ ▝▀▀▀▀▘    ▝▀▀▀▀▀▀▀▀▘   ▝▀▀▀▀▀▀▀▀▀▀▀▀▘  
`
      } else if (frame < 94) {
        text += `\n██████████████▄▖ ██████▄▖      ████▄▖   ████████████▄▖   ████▄▖
██████████████▜▌ ██████▜▌      ████▜▌   ████████████▜▌   ████▜▌
████▗▄▄▄▄▄▄▄▄▄▟▌ ████████▄▖    ████▐▌ ████▗▄▄▄▄▄▄▄▄▄▟▌   ████▐▌
████▐▛▀▀▀▀▀▀▀▀▀▘ ████████▜▌    ████▐▌ ████▐▛▀▀▀▀▀▀▀▀▀▘   ████▐▌
██████████▄▖     ████▗▄████▄▖  ████▐▌ ████▐▌    ██████▄▖ ████▐▌
██████████▜▌     ████▐▛████▜▌  ████▐▌ ████▐▌    ██████▜▌ ████▐▌
████▗▄▄▄▄▄▟▌     ████▐▌▐▙████▄▖████▐▌ ████▐▌      ████▐▌ ████▐▌
████▐▛▀▀▀▀▀▘     ████▐▌▝▀████▜▌████▐▌ ████▐▌      ████▐▌ ████▐▌
██████████████▄▖ ████▐▌  ▐▙████████▐▌ ▐▙████████████▗▄▟▌ ████▐▌
██████████████▜▌ ████▐▌  ▝▀████████▐▌ ▝▀████████████▐▛▀▘ ████▐▌
▐▙▄▄▄▄▄▄▄▄▄▄▄▄▟▌ ▐▙▄▄▟▌    ▐▙▄▄▄▄▄▄▟▌   ▐▙▄▄▄▄▄▄▄▄▄▄▟▌   ▐▙▄▄▟▌
▝▀▀▀▀▀▀▀▀▀▀▀▀▀▀▘ ▝▀▀▀▀▘    ▝▀▀▀▀▀▀▀▀▘   ▝▀▀▀▀▀▀▀▀▀▀▀▀▘   ▝▀▀▀▀▘
`
      } else if (frame < 95) {
        text += `\n██████████████▄▖ ██████▄▖      ████▄▖   ████████████▄▖   ████▄▖ ██████▄▖      ████▄▖
██████████████▜▌ ██████▜▌      ████▜▌   ████████████▜▌   ████▜▌ ██████▜▌      ████▜▌
████▗▄▄▄▄▄▄▄▄▄▟▌ ████████▄▖    ████▐▌ ████▗▄▄▄▄▄▄▄▄▄▟▌   ████▐▌ ████████▄▖    ████▐▌
████▐▛▀▀▀▀▀▀▀▀▀▘ ████████▜▌    ████▐▌ ████▐▛▀▀▀▀▀▀▀▀▀▘   ████▐▌ ████████▜▌    ████▐▌
██████████▄▖     ████▗▄████▄▖  ████▐▌ ████▐▌    ██████▄▖ ████▐▌ ████▗▄████▄▖  ████▐▌
██████████▜▌     ████▐▛████▜▌  ████▐▌ ████▐▌    ██████▜▌ ████▐▌ ████▐▛████▜▌  ████▐▌
████▗▄▄▄▄▄▟▌     ████▐▌▐▙████▄▖████▐▌ ████▐▌      ████▐▌ ████▐▌ ████▐▌▐▙████▄▖████▐▌
████▐▛▀▀▀▀▀▘     ████▐▌▝▀████▜▌████▐▌ ████▐▌      ████▐▌ ████▐▌ ████▐▌▝▀████▜▌████▐▌
██████████████▄▖ ████▐▌  ▐▙████████▐▌ ▐▙████████████▗▄▟▌ ████▐▌ ████▐▌  ▐▙████████▐▌
██████████████▜▌ ████▐▌  ▝▀████████▐▌ ▝▀████████████▐▛▀▘ ████▐▌ ████▐▌  ▝▀████████▐▌
▐▙▄▄▄▄▄▄▄▄▄▄▄▄▟▌ ▐▙▄▄▟▌    ▐▙▄▄▄▄▄▄▟▌   ▐▙▄▄▄▄▄▄▄▄▄▄▟▌   ▐▙▄▄▟▌ ▐▙▄▄▟▌    ▐▙▄▄▄▄▄▄▟▌
▝▀▀▀▀▀▀▀▀▀▀▀▀▀▀▘ ▝▀▀▀▀▘    ▝▀▀▀▀▀▀▀▀▘   ▝▀▀▀▀▀▀▀▀▀▀▀▀▘   ▝▀▀▀▀▘ ▝▀▀▀▀▘    ▝▀▀▀▀▀▀▀▀▘
`
      } else {
        text += `\n██████████████▄▖ ██████▄▖      ████▄▖   ████████████▄▖   ████▄▖ ██████▄▖      ████▄▖ ██████████████▄▖
██████████████▜▌ ██████▜▌      ████▜▌   ████████████▜▌   ████▜▌ ██████▜▌      ████▜▌ ██████████████▜▌
████▗▄▄▄▄▄▄▄▄▄▟▌ ████████▄▖    ████▐▌ ████▗▄▄▄▄▄▄▄▄▄▟▌   ████▐▌ ████████▄▖    ████▐▌ ████▗▄▄▄▄▄▄▄▄▄▟▌
████▐▛▀▀▀▀▀▀▀▀▀▘ ████████▜▌    ████▐▌ ████▐▛▀▀▀▀▀▀▀▀▀▘   ████▐▌ ████████▜▌    ████▐▌ ████▐▛▀▀▀▀▀▀▀▀▀▘
██████████▄▖     ████▗▄████▄▖  ████▐▌ ████▐▌    ██████▄▖ ████▐▌ ████▗▄████▄▖  ████▐▌ ██████████▄▖    
██████████▜▌     ████▐▛████▜▌  ████▐▌ ████▐▌    ██████▜▌ ████▐▌ ████▐▛████▜▌  ████▐▌ ██████████▜▌    
████▗▄▄▄▄▄▟▌     ████▐▌▐▙████▄▖████▐▌ ████▐▌      ████▐▌ ████▐▌ ████▐▌▐▙████▄▖████▐▌ ████▗▄▄▄▄▄▟▌    
████▐▛▀▀▀▀▀▘     ████▐▌▝▀████▜▌████▐▌ ████▐▌      ████▐▌ ████▐▌ ████▐▌▝▀████▜▌████▐▌ ████▐▛▀▀▀▀▀▘    
██████████████▄▖ ████▐▌  ▐▙████████▐▌ ▐▙████████████▗▄▟▌ ████▐▌ ████▐▌  ▐▙████████▐▌ ██████████████▄▖
██████████████▜▌ ████▐▌  ▝▀████████▐▌ ▝▀████████████▐▛▀▘ ████▐▌ ████▐▌  ▝▀████████▐▌ ██████████████▜▌
▐▙▄▄▄▄▄▄▄▄▄▄▄▄▟▌ ▐▙▄▄▟▌    ▐▙▄▄▄▄▄▄▟▌   ▐▙▄▄▄▄▄▄▄▄▄▄▟▌   ▐▙▄▄▟▌ ▐▙▄▄▟▌    ▐▙▄▄▄▄▄▄▟▌ ▐▙▄▄▄▄▄▄▄▄▄▄▄▄▟▌
▝▀▀▀▀▀▀▀▀▀▀▀▀▀▀▘ ▝▀▀▀▀▘    ▝▀▀▀▀▀▀▀▀▘   ▝▀▀▀▀▀▀▀▀▀▀▀▀▘   ▝▀▀▀▀▘ ▝▀▀▀▀▘    ▝▀▀▀▀▀▀▀▀▘ ▝▀▀▀▀▀▀▀▀▀▀▀▀▀▀▘
`
      }
    }
    return (
      <>
        {text}
        {frame > 96 ? (
          <>
            {`                                                                                                     \n`}
            {`      `}
            <Link to="/portfolios">{`  ┏┓┏━┓     ┏┓  ┏━━━┓     ┏┓┏┓   ┏┓ `}</Link>
            {`        |                `}
            <Link to="/about">{`┏━━━┓  ┏┓┏┳┓ ┏┓ ┏┓  `}</Link>
            {`              \n`}
            {`      `}
            <Link to="/portfolios">{`┏━┛┗┃○┃     ┃┃  ┗━━┓┃  ┏┓ ┃┃┃┃┏━━┛┗┓`}</Link>
            {`        |                `}
            <Link to="/about">{`┗┓┏┓┃┏┓┃┃┃┃┃┏┛┗┓┃┃  `}</Link>
            {`              \n`}
            {`      `}
            <Link to="/portfolios">{`┗━┓┏┗━┛┏━━━┓┃┗━┓   ┃┃┏━┛┗┓┃┃┃┃┗━┓ ┏┛`}</Link>
            {`        |                `}
            <Link to="/about">{` ┃┣┛┃┃┃┃┃┗┻┛┃┏┓┃┃┗━┓`}</Link>
            {`              \n`}
            {`      `}
            <Link to="/portfolios">{`┏┓┃┃┏┓ ┗━━━┛┃┏━┛  ┏┛┃┗┓ ┏┛┗┛┃┃ ┏┛┃┃ `}</Link>
            {`        |                `}
            <Link to="/about">{` ┃┣━┛┃┃┃┃   ┗┛┃┃┃┏━┛`}</Link>
            {`              \n`}
            {`      `}
            <Link to="/portfolios">{`┃┃┃┃┃┃      ┃┃   ┏┛┏┛┏┛┃┃  ┏┛┃┏┛┏┫┃ `}</Link>
            {`        |                `}
            <Link to="/about">{` ┃┃  ┃┃┃┃    ┏┛┃┃┃  `}</Link>
            {`              \n`}
            {`      `}
            <Link to="/portfolios">{`┗┛┗┛┗┛      ┗┛   ┗━┛ ┗━┻┛  ┗━┛┗━┛┗┛ `}</Link>
            {`        |                `}
            <Link to="/about">{` ┗┛  ┗┛┗┛    ┗━┛┗┛  `}</Link>
            {`              \n`}
            {`                                                                                                     \n`}
          </>
        ) : null}
      </>
    )
  }, [frame])

  const resize = React.useCallback(() => {
    if (!preRef.current) return
    setScale(preRef.current.clientWidth / 800)
  }, [preRef, setScale])

  React.useEffect(() => {
    resize()
  }, [resize])

  React.useEffect(() => {
    const id = setInterval(() => {
      setFrame((frame) => (frame < MAX_FRAME ? frame + 1 : frame))
    }, 100)
    return () => clearInterval(id)
  }, [setFrame])

  useWindowEvent('resize', resize)

  return (
    <div className="bg-gray-900 w-full h-full flex flex-col p-2 px-4 overflow-x-hidden relative">
      <pre
        ref={preRef}
        className="text-xs font-mono text-gray-50 transform origin-top-left"
        style={{
          '--tw-scale-x': scale,
          '--tw-scale-y': scale,
        }}
      >
        {Text}
      </pre>
      {frame > 99 ? (
        <div
          className="text-right absolute right-12 transform origin-bottom-right"
          style={{
            top: 410 * scale,
            '--tw-scale-x': scale,
            '--tw-scale-y': scale,
          }}
        >
          <button
            className="focus:outline-none border border-white text-white py-1 px-3"
            onClick={() => setFrame(0)}
          >
            reset
          </button>
        </div>
      ) : null}
    </div>
  )
}
